import styles from "./AboutUs.module.css";
import { FaCheckCircle, FaInfinity, FaUsers } from "react-icons/fa";

const AboutUs = () => {
  const features = [
    {
      icon: <FaUsers />,

      title: "Industry Leaders",
      description:
        "Internationally accredited programs backed by Japanese education experts and STEM.org USA certification.",
    },
    {
      icon: <FaCheckCircle />,

      title: "Complete Solution",
      description:
        "End-to-end implementation from lab setup and curriculum to teacher training and competitions at your school.",
    },
    {
      icon: <FaInfinity />,
      title: "Flexible",
      description:
        "Our online private STEM program has students from all over the world, including from India, Dubai, USA, Singapore, England, Nepal, South Africa, Canada, and Japan. Our offline STEMx Studios in Bangalore are located across Whitefield and Indiranagar.",
    },
  ];

  return (
    <section className={styles.aboutUs}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title} data-aos="fade-up">
            About Us
          </h2>
          <p
            className={styles.subtitle}
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Transform your school with world-class STEM education, from robotics
            and AI to hands-on innovation labs and global competitions.
          </p>
        </div>

        <div className={styles.features}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.iconWrapper}>{feature.icon}</div>
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.featureDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
